import React from "react";
import { useIntl } from "react-intl";

import { PurLine, PurResource } from "react-lib/apis/PUR/purApi";

interface PurLineTableProps { resource: PurResource; lines: PurLine[] }

const HEADERS: Record<PurResource, string[]> = {
  materialRequests: ["MEERP_REQUESTED_QUANTITY", "MEERP_ORDERED_QUANTITY", "MEERP_CONVERSION_FACTOR", "MEERP_STOCK_QUANTITY"],
  purchaseOrders: ["MEERP_ORDERED_QUANTITY", "MEERP_ACCEPTED_TO_DATE", "MEERP_INVOICED_QUANTITY", "MEERP_CONVERSION_FACTOR", "MEERP_STOCK_QUANTITY", "MEERP_PACKAGE_COST", "MEERP_BASE_UNIT_COST", "MEERP_BILLED_AMOUNT"],
  receipts: ["MEERP_DELIVERED_QUANTITY", "MEERP_ACCEPTED_QUANTITY", "MEERP_REJECTED_QUANTITY", "MEERP_REJECTION_REASON", "MEERP_CONVERSION_FACTOR", "MEERP_STOCK_QUANTITY", "MEERP_REJECTED_STOCK_QUANTITY", "MEERP_PACKAGE_COST", "MEERP_BASE_UNIT_COST", "MEERP_BATCH", "MEERP_MANUFACTURED", "MEERP_EXPIRES", "MEERP_PO_LINE_ID"],
};

const cells = (line: PurLine): Array<string | number | null> => {
  switch (line.kind) {
    case "materialRequests": return [line.requestedQuantity, line.orderedQuantity, line.conversionFactor, line.stockQuantity];
    case "purchaseOrders": return [line.orderedQuantity, line.receivedQuantity, line.invoicedQuantity, line.conversionFactor, line.stockQuantity, line.unitCost, line.baseUnitCost, line.billedAmount];
    case "receipts": return [line.deliveredQuantity, line.acceptedQuantity, line.rejectedQuantity, line.rejectionReason, line.conversionFactor, line.stockQuantity, line.rejectedStockQuantity, line.unitCost, line.baseUnitCost, line.batchNumber, line.manufactureDate, line.expiryDate, line.poItemId];
  }
};

const PurLineTable: React.FC<PurLineTableProps> = ({ resource, lines }) => {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const label = (value: string | number | null) => value === null || value === undefined || value === "" ? t("MEERP_UNKNOWN") : String(value);
  return <>
    <p className="card-meerp__muted">{t("MEERP_UNIT_SERVER_NOTE")}</p>
    {resource === "receipts" && <p className="card-meerp__muted">{t("MEERP_RECEIPT_QUANTITY_NOTE")}</p>}
    <div className="card-meerp__table-wrap"><table className="card-meerp__table">
      <caption className="card-meerp__sr-only">{t("MEERP_ITEMS")}</caption>
      <thead><tr>{["MEERP_PRODUCT", "MEERP_PRODUCT_ID", "MEERP_PACKAGE_UNIT", ...HEADERS[resource]].map((id) => <th scope="col" key={id}>{t(id)}</th>)}</tr></thead>
      <tbody>{lines.map((line, index) => <tr key={line.id ?? index}>
        <td>{label(line.productName)}</td><td>{label(line.productId)}</td><td>{label(line.unitName)}</td>
        {cells(line).map((value, column) => <td key={column}>{label(value)}</td>)}
      </tr>)}</tbody>
    </table></div>
  </>;
};

export default PurLineTable;
